/**
 * 1.65 — the need record (the till's „ჩაწერე მოთხოვნა", the stock manager's „მოთხოვნები") and the supplier
 * order (the builder, the order's sheet, receiving from it). What the supplier receives is NOT here: it is a
 * document, Georgian whatever the device speaks (lib/supplier-order.ts).
 */
export const need = {
  // the till
  'need.record': 'ჩაწერე მოთხოვნა',
  'need.title': 'ჩაწერე მოთხოვნა',
  'need.sub': 'მყიდველს ეს უნდა — მფლობელი ნახავს',
  'need.what': 'რა უნდა?',
  'need.whatPh': 'მაგ. ნათურა H7',
  'need.qty': 'რამდენი?',
  'need.less': 'ერთით ნაკლები',
  'need.more': 'ერთით მეტი',
  'need.contact': 'ვის დავურეკოთ?',
  'need.optional': '(არასავალდებულო)',
  'need.contactPh': 'სახელი და ტელეფონი',
  'need.addNote': '+ შენიშვნა',
  'need.note': 'შენიშვნა',
  'need.save': 'ჩაწერა',
  'need.saved': 'ჩაიწერა',
  'need.savedDesc': 'მფლობელი ნახავს',
  'need.recordText': 'ჩაწერე მოთხოვნა: „{q}"',
  'need.anyway': 'მაინც ეს უნდა — ჩაწერე მოთხოვნა',
  'need.tileHint': 'შეეხე — ჩაწერე მოთხოვნა',
  'need.err.name': 'დაწერე, რა უნდა მყიდველს (120 სიმბოლომდე)',
  'need.err.qty': 'რაოდენობა 0-ზე მეტი უნდა იყოს',
  'need.err.contact': 'კონტაქტი — 80 სიმბოლომდე',
  'need.err.note': 'შენიშვნა — 200 სიმბოლომდე',
  'need.failed': 'ვერ ჩაიწერა — მოწყობილობა ვერ ინახავს და ინტერნეტიც არ არის. სცადე თავიდან',
  // the stock manager's tab
  'need.tab': 'მოთხოვნები',
  'need.arrived': 'მოვიდა — დაურეკე',
  'need.arrivedHint': 'თაროზე ისევ არის',
  'need.missing': 'არ გვაქვს',
  'need.freeText': 'კატალოგში არ არის',
  'need.times': '{n}-ჯერ',
  'need.call': 'დარეკვა',
  'need.whatsapp': 'WhatsApp',
  'need.called': 'დავურეკე ✓',
  'need.close': 'დახურვა',
  'need.noContact': 'კონტაქტის გარეშე',
  'need.ordered': 'შეკვეთილია',
  'need.asked': 'მოითხოვეს ×{n}',
  'need.colAsked': 'მოითხოვეს',
  'need.colLast': 'ბოლოს',
  'need.empty': 'მოთხოვნები არ არის. როცა მყიდველი რამეს ითხოვს და არ გაქვს, სალაროში „ჩაწერე მოთხოვნა" დააჭირე.',
  'need.loadFailed': 'მოთხოვნები ვერ ჩაიტვირთა — შეამოწმე ინტერნეტი',
  'need.closed': 'დაიხურა',
  // the order builder
  'sorder.build': 'შეკვეთის შედგენა',
  'sorder.buildN': 'შეკვეთის შედგენა ({n})',
  'sorder.picked': 'მონიშნულია {n}',
  'sorder.builderSub': 'დაიყო მომწოდებლებად — ვისგან იყიდე ბოლოს',
  'sorder.branch': 'ფილიალი: {name}',
  'sorder.pickBranch': 'ჯერ აირჩიე ფილიალი, რომლისთვისაც უკვეთავ',
  'sorder.noSupplier': 'მომწოდებელი არ არის — ბაზრის სია',
  'sorder.supplier': 'მომწოდებელი',
  'sorder.colQty': 'რაოდენობა',
  'sorder.colLastCost': 'ბოლო ფასი',
  'sorder.colEstimate': 'სავარაუდო',
  'sorder.addProduct': 'დაამატე პროდუქტი ძებნით ან სკანერით',
  'sorder.note': 'შენიშვნა მომწოდებლისთვის',
  'sorder.summary': '{n} შეკვეთა · სავარაუდო {sum}',
  'sorder.privateSum': 'მომწოდებელი ფასს ვერ ხედავს',
  'sorder.save': 'შენახვა',
  'sorder.saved': 'შეკვეთა შენახულია ({n})',
  'sorder.remove': 'წაშლა',
  'sorder.err.needTaken': 'ეს მოთხოვნა სხვა შეკვეთაში უკვე შევიდა — სია განახლდა',
  'sorder.err.done': 'ეს შეკვეთა უკვე მიღებულია ან დახურულია',
  'sorder.err.branch': 'ეს შეკვეთა სხვა ფილიალისაა — მისაღებად ჯერ მის ფილიალზე გადადი',
  'sorder.err.empty': 'შეკვეთაში ერთი სტრიქონი მაინც უნდა იყოს',
  // the order's sheet
  'sorder.title': 'შეკვეთა {n}',
  'sorder.status.open': 'ღიაა',
  'sorder.status.received': 'მიღებულია',
  'sorder.status.closed': 'დახურულია',
  'sorder.status.cancelled': 'გაუქმებულია',
  'sorder.sentAt': 'გაიგზავნა {at}',
  'sorder.estimate': 'სავარაუდო თანხა: {sum} — მხოლოდ შენ ხედავ',
  'sorder.send': 'გაგზავნა',
  'sorder.copy': 'ტექსტის კოპირება',
  'sorder.copied': 'ტექსტი დაკოპირდა — ჩასვი WhatsApp-ში ან Viber-ში',
  'sorder.print': 'ბეჭდვა A4',
  'sorder.receive': 'მიღება — საქონელი მოვიდა',
  'sorder.receiveHint': 'შესყიდვის ფანჯარა გაიხსნება უკვე შევსებული. გაასწორე ის, რაც რეალურად მოვიდა, და შეინახე — შეკვეთა იმავე წამს დაიხურება.',
  'sorder.edit': 'რედაქტირება',
  'sorder.closeOther': 'მიღებულია სხვა გზით (ზედნადებით)',
  'sorder.cancel': 'შეკვეთის გაუქმება',
  'sorder.confirmClose': 'შეკვეთა დაიხუროს, როგორც მიღებული?',
  'sorder.confirmCloseDesc': 'მარაგს არაფერი დაემატება — საქონელი სხვა გზით (მაგ. RS.GE ზედნადებით) უკვე მიიღე.',
  'sorder.confirmCancel': 'შეკვეთა გაუქმდეს?',
  'sorder.confirmCancelDesc': 'მისი მოთხოვნები ისევ „მოთხოვნებში" დაბრუნდება.',
  'sorder.colOrdered': 'შეკვეთილი',
  'sorder.colReceived': 'მოვიდა',
  'sorder.freeTextLines': 'კატალოგში არ არის — ჯერ დაამატე პროდუქტი:',
  'sorder.fromOrder': 'შეკვეთა {n}',
  // the suppliers page
  'sorder.chip': 'შეკვეთები · {n}',
  'sorder.tab': 'შეკვეთები',
  'sorder.new': 'ახალი შეკვეთა',
  'sorder.none': 'შეკვეთები ჯერ არ არის',
  'sorder.openList': 'ღია შეკვეთები',
  'sorder.marked': 'შეკვეთილია {qty} · {date}',
  'sorder.lines': '{n} სტრიქონი',
} as const
